export default __webpack_public_path__ + "static/media/330_dummy2016-naeherin01-mobile-de.070c970e.png";